import * as React from 'react';
export const boostSvg = React.forwardRef(function boostSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EE3124',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.856 5.214C9.283 4.41 10.744 4 12.204 4c2.247 0 3.723.984 3.773 1.034 3.971 2.396 4.086 6.35 4.086 6.908.575-.017 4.512.098 6.924 4.117.017 0 2.396 3.495-.196 8.105-1.345 2.51-4.086 3.414-4.89 3.627-.476.131-.887.181-1.658.23h-9.22s-.624 0-1.264-.164a10.93 10.93 0 0 1-1.46-.492c-.542-.246-1.165-.591-2.018-1.444l-.131-.131c-.673-.69-1.329-1.658-1.657-2.479a6.42 6.42 0 0 1-.345-1.132A6.208 6.208 0 0 1 4 20.867v-9.09c.05-.787.115-1.214.23-1.673.213-.804 1.1-3.545 3.626-4.89Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.204 4c-1.46 0-2.92.41-4.348 1.214C5.329 6.559 4.443 9.3 4.23 10.104c-.115.46-.18.886-.23 1.673v9.09c0 .05 0 .706.148 1.312.099.443.165.673.345 1.133.328.82.984 1.788 1.657 2.478l.13.13c.854.854 1.477 1.199 2.019 1.445.459.197 1.017.377 1.46.492a5.78 5.78 0 0 0 1.264.164h9.22c.771-.049 1.182-.099 1.658-.23.804-.213 3.545-1.116 4.89-3.627 2.592-4.61.213-8.105.196-8.105-2.412-4.02-6.35-4.134-6.924-4.117 0-.558-.115-4.512-4.086-6.908C15.927 4.984 14.451 4 12.204 4Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.116 17.754c-.673-1.313-1.838-2.133-3.462-2.462-.131-.032-.262-.032-.394-.049l-.18-.016a3.369 3.369 0 0 0-.509-.033h-2.773V12.57c0-.345-.016-.525-.033-.656l-.016-.18c-.016-.132-.033-.28-.05-.395-.327-1.624-1.148-2.805-2.46-3.462a4.882 4.882 0 0 0-1.936-.525h-.148a4.32 4.32 0 0 0-.673.05c-4.299.574-4.25 4.709-4.233 4.873v7.646c0 1.542.427 2.756 1.247 3.61.853.82 2.067 1.23 3.593 1.23h7.695c.427 0 4.283-.115 4.84-4.233.034-.263.05-.476.05-.82-.017-.017-.033-.936-.558-1.953Z',
      fill: '#EE3124',
    }),
  );
});
boostSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var boost = {
  category: 'brand',
  colorable: false,
  name: 'boost',
  svg: boostSvg,
};
